// extracted by mini-css-extract-plugin
module.exports = {"category":"styles-m__category__1H81M","category-icon":"styles-m__category-icon__3ofNK","category-name":"styles-m__category-name__2iIyY"};